// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3evBt","header":"MessagesList_header__aMHkr","chat":"MessagesList_chat__3P-nC"};